import { useEffect } from 'react';
import { useLocation } from 'react-router';

export default function useScrollToTop() {
  const { pathname } = useLocation();

  // scroll top if path changed
  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  // scroll top if scroll location is below scren size
  if (window.scrollY > window.screen.height) scrollToTop();
}

export const scrollToTop = () => scrollTo(0);

export function scrollToElementById(elId: string, shift = 0) {
  const el = document.getElementById(elId);
  if (!el) {
    throw new Error(`Element with id=${elId} not found in the document!`);
  }
  const { top, left } = el.getBoundingClientRect();
  const offsetY = window.scrollY;
  const offsetX = window.scrollX;
  scrollTo(top + offsetY + shift, left + offsetX);
}

function scrollTo(top: number, left = 0) {
  try {
    window.scrollTo({ top, left, behavior: 'smooth' });
  } catch {
    window.scrollTo(top, left);
  }
}
